export default __webpack_public_path__ + "static/media/2_3-card.0f5859e0.png";